import { render, staticRenderFns } from "./LayoverHeader.vue?vue&type=template&id=4b46f947"
import script from "./LayoverHeader.vue?vue&type=script&lang=js"
export * from "./LayoverHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports